import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { AppService } from '../../app.service';
declare let $;

export interface ITreeNode {
  data?: any;
  children?: TreeNode[];
  leaf?: boolean;
  expanded?: boolean;
}
@Component({
  selector: 'si-file-download-popup',
  templateUrl: './file-download-popup.component.html',
  styleUrls: ['./file-download-popup.component.scss']
})


export class FileDownloadPopupComponent implements OnInit, OnChanges {
  @Input() overlayConfig: Array<object>;
  @Input() highRiskConfig: Array<object>;
  @Input() overlayResponse: Array<object>;
  @Input() overlayOriginatingResponse: Array<object>;
  @Input() ticketingConfig: Array<object>;
  @Input() highRiskResponse: Array<object>;
  @Input() ticketingResponse: Array<object>;
  @Input() neustarMailConfig: Array<object>;
  @Input() customerMailConfig: Array<object>;
  @Input() verstatConfig: Array<object>;
  @Input() verstatResponse: Array<object>;
  @Output() emitRowData = new EventEmitter();
  @Output() initializedOverlayFiles = new EventEmitter();
  @Output() initializedOverlayOriginatingFiles = new EventEmitter();
  @Output() initializedHighRiskFiles = new EventEmitter();
  @Output() initializedTicketingFiles = new EventEmitter();
  @Output() initializedVerstatFiles = new EventEmitter();
  overlayFileDownloadData: Array<object>;
  overlayOriginatingFileDownloadData: Array<object>;
  highRiskFileDownloadData: Array<object>;
  ticketingDownloadData: Array<object>;
  verstatDownloadData: Array<object>;
  fetchingFilesFlag: boolean = false;
  activeCustomer: string;

  isActiveOverlay: boolean = true;
  isActiveHighRisk: boolean = false;

  constructor(private appService: AppService) {
    this.activeCustomer = this.appService.getActiveCustomerAndFormat();
  }

  ngOnChanges() {
    if (this.overlayResponse !== undefined && this.overlayResponse.length !== 0) {
      this.overlayFileDownloadData = this.overlayResponse;
      this.fetchingFilesFlag = false;
    }

    if (this.overlayOriginatingResponse !== undefined && this.overlayOriginatingResponse.length !== 0) {
      this.overlayOriginatingFileDownloadData = this.overlayOriginatingResponse;
      this.fetchingFilesFlag = false;
    }

    if (this.highRiskResponse !== undefined && this.highRiskResponse.length !== 0) {
      this.highRiskFileDownloadData = this.highRiskResponse;
      this.fetchingFilesFlag = false;
    }

    if (this.ticketingResponse !== undefined && this.ticketingResponse.length !== 0) {
      this.ticketingDownloadData = this.ticketingResponse;
      this.fetchingFilesFlag = false;
    }

    if (this.verstatResponse !== undefined && this.verstatResponse.length !== 0) {
      this.verstatDownloadData = this.verstatResponse;
      this.fetchingFilesFlag = false;
    }

    this.appService.tokenExpireStatus.subscribe((value) => {
      this.closeModal();
    });
  }

  ngOnInit() {
    const self = this;
    $('#headerFileDownload').on('show.bs.modal', function (e) {
      self.fetchingFilesFlag = true;
      if (self.overlayConfig['isOverlayFileVisible']) {
        self.initializedOverlayFiles.next(true);
      }

      if (self.overlayConfig['isOverlayOriginatingFileVisible']) {
        self.initializedOverlayOriginatingFiles.next(true);
      }

      if (self.highRiskConfig['isHighRiskFileVisible']) {
        self.initializedHighRiskFiles.next(true);
      }

      if (self.ticketingConfig['isTicketingFileVisible']) {
        self.initializedTicketingFiles.next(true);
      }

      if(self.verstatConfig['isVerstatFileVisible']) {
        self.initializedVerstatFiles.next(true);
      }

    });
  }
  downloadFile(rowdata) {
    this.emitRowData.next(rowdata);
  }
  resetFiles() {
    this.fetchingFilesFlag = true;

    if (this.overlayConfig['isOverlayFileVisible']) {
      this.initializedOverlayFiles.next(true);
    }

    if (this.overlayConfig['isOverlayOriginatingFileVisible']) {
      this.initializedOverlayOriginatingFiles.next(true);
    }

    if (this.highRiskConfig['isHighRiskFileVisible']) {
      this.initializedHighRiskFiles.next(true);
    }

    if (this.ticketingConfig['isTicketingFileVisible']) {
      this.initializedTicketingFiles.next(true);
    }

    if(this.verstatConfig['isVerstatFileVisible']) {
      this.initializedVerstatFiles.next(true);
    }
  }
  closeModal() {
    $('#headerFileDownload').modal('hide');
  }

  setActiveTab(selectedTab) {
    this.isActiveHighRisk = this.isActiveHighRisk === false ? true : false;
    this.isActiveOverlay = this.isActiveOverlay === true ? false : true;
  }
}
